import { Component, OnInit } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationError,
  ActivatedRoute,
} from '@angular/router';
import * as rg4js from 'raygun4js';
import { AppConfig } from './app-config';
import { Title } from '@angular/platform-browser';
import { SignalrService } from './content-management/shared/services/signalr.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  appTitle: string;
  constructor(
    private router: Router,
    private appConfig: AppConfig,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private signalRService: SignalrService
  ) {}

  ngOnInit() {
    let ua = navigator.userAgent;
    const isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    if (isIE) {
      alert(
        'We do not support IE and you may encounter issues, please use a different supported browser like Chrome, Edge or Firefox.'
      );
    }

    this.signalRService.initiateSignalrConnection();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Track navigation end
        if (this.appConfig.isRaygunEnabled) {
          rg4js('trackEvent', {
            type: 'pageView',
            path: event.url,
          });
        }
        let moduleTitle =
          this.activatedRoute.firstChild.snapshot.firstChild.data['title'];

        this.appTitle = moduleTitle
          ? moduleTitle
          : this.titleService.getTitle();

        this.titleService.setTitle(this.appTitle);
      } else if (
        event instanceof NavigationError &&
        this.appConfig.isRaygunEnabled
      ) {
        // Track navigation error
        rg4js('send', {
          error: event.error,
        });
      }
    });
  }
}
